export class MultiBeadChipUpdate{
  "beadchipids" : string[];
  "labid":string;
  "step":string;
  "status":string;
  "puid":string;
  "actionRunTime":number;
  "action":string;
  "beadChipUpdateInfoList" : BeadChipUpdateInfo[];
  "liquidHandler": string;
  "chemicals": Array<any>;
  "machineUpdateInfoDict" = new Map();
  "workFlow"?: string = "";
  "sender"?: string = "";
  "lastUpdatedPlateID"?: string;
  "addFirstAction"?: any = null;
  "completeProcessStep"?: boolean = false;
  "processStartTimeStamp"?: string;
}

export class BeadChipUpdateInfo{
  beadChipID: string;
  liquidHandler: string;
  chemicals: Array<any>;
  lastUpdatedPlateID:string;
  addFirstAction: any;
  status?: string;
  sampleType?: string;
  stepName?: string;
}

export class WashAndStainPrepRequestDTO{
  labid: string;
  processFlowNames: Array<String>;
}

export class WashAndStainArraysListDTO{
  labID: string;
  plateIDs: Array<String>;
  liquidHandlers: Array<String>;
  startTime: Date;
  puid: String;
}

export class WashAndStainPrepUpdateDTO{
  labid: string;
  puid: string;
  arrayList: Array<string>;
  actionsList: Array<string>
  actionsData: any;
  processStep: string;
  status: string;
}

export class Axiom384PlateMeta {
  quadrant: string;
  plateID: string;
  lastUpdatedID: string;
  status: string;
}